import { Component } from 'react'
import { IClientUID } from '../../../api/clients'
import { toast } from 'react-toastify'
import { getString } from '../../../locale'
import { restartClient } from '../../../api/0x0002/restart'
import { PeripheralType, updateClientPeripherals } from '../../../api/0x0002/peripheral'
import { getClientTestEnvironment, updateClientTestEnvironment } from '../../../api/0x0002/test-environment'
import classNames from 'classnames'
import SystemInfo from './fragmented-systeminfo.tab'

type Props = {
    clientId: IClientUID
}

type State = {
    working: boolean
    testEnv?: boolean
    relSol1BtnPressing: boolean
    relSol2BtnPressing: boolean
    relSol3BtnPressing: boolean
    relSol4BtnPressing: boolean
    relSol5BtnPressing: boolean
    relSol6BtnPressing: boolean
    relSol7BtnPressing: boolean
    relSol8BtnPressing: boolean
}

class SystemActionsTab extends Component<Props, State> {
    state: State = {
        working: false,
        testEnv: undefined,
        relSol1BtnPressing: false,
        relSol2BtnPressing: false,
        relSol3BtnPressing: false,
        relSol4BtnPressing: false,
        relSol5BtnPressing: false,
        relSol6BtnPressing: false,
        relSol7BtnPressing: false,
        relSol8BtnPressing: false,
    }

    keyPressEventListener = (event: KeyboardEvent) => {
        switch (event.key) {
            case '1':
                if (!this.state.relSol1BtnPressing) this.handleRelSol1ButtonPress()
                else this.handleRelSol1ButtonRelease()
                break
            case '2':
                if (!this.state.relSol2BtnPressing) this.handleRelSol2ButtonPress()
                else this.handleRelSol2ButtonRelease()
                break
            case '3':
                if (!this.state.relSol3BtnPressing) this.handleRelSol3ButtonPress()
                else this.handleRelSol3ButtonRelease()
                break
            case '4':
                if (!this.state.relSol4BtnPressing) this.handleRelSol4ButtonPress()
                else this.handleRelSol4ButtonRelease()
                break
            case '5':
                if (!this.state.relSol5BtnPressing) this.handleRelSol5ButtonPress()
                else this.handleRelSol5ButtonRelease()
                break
            case '6':
                if (!this.state.relSol6BtnPressing) this.handleRelSol6ButtonPress()
                else this.handleRelSol6ButtonRelease()
                break
            case '7':
                if (!this.state.relSol7BtnPressing) this.handleRelSol7ButtonPress()
                else this.handleRelSol7ButtonRelease()
                break
            case '8':
                if (!this.state.relSol8BtnPressing) this.handleRelSol8ButtonPress()
                else this.handleRelSol8ButtonRelease()
                break
        }
    }

    componentDidMount = async () => {
        await this.getTestEnv()

        document.addEventListener('keypress', this.keyPressEventListener)
    }

    componentWillUnmount = () => {
        document.removeEventListener('keypress', this.keyPressEventListener)
    }

    async getTestEnv() {
        try {
            const testEnv = (await getClientTestEnvironment(this.props.clientId)).data
            console.log('testEnv', testEnv)
            this.setState({ testEnv })
        } catch (err) {
            toast.error((err as Error).message)
            console.error(err)
        }
    }

    async toggleTestEnv() {
        try {
            this.setState({ working: true })
            const result = await updateClientTestEnvironment(this.props.clientId, !this.state.testEnv)
            console.log('toggleTestEnv result', result)
            this.getTestEnv()
        } catch (err) {
            toast.error((err as Error).message)
            console.error(err)
        }
        this.setState({ working: false })
    }

    async saveSystemAction() {
        try {
            this.setState({ working: true })
            await restartClient(this.props.clientId)
            toast.dark(getString('system_actions.restart_message'), {
                pauseOnHover: false,
                pauseOnFocusLoss: false,
                closeButton: false,
                closeOnClick: false,
                draggable: false,
                autoClose: 1000,
            })
        } catch (err) {
            this.setState({ working: false })
            toast.error((err as Error).message)
            console.error(err)
        }
    }

    handleRelSol1ButtonPress = async () => {
        try {
            if (!this.state.relSol1BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol1, state: true })
                this.setState({ relSol1BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol1ButtonRelease = async () => {
        try {
            if (this.state.relSol1BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol1, state: false })
                this.setState({ relSol1BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol2ButtonPress = async () => {
        try {
            if (!this.state.relSol2BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol2, state: true })
                this.setState({ relSol2BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol2ButtonRelease = async () => {
        try {
            if (this.state.relSol2BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol2, state: false })
                this.setState({ relSol2BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol3ButtonPress = async () => {
        try {
            if (!this.state.relSol3BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol3, state: true })
                this.setState({ relSol3BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol3ButtonRelease = async () => {
        try {
            if (this.state.relSol3BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol3, state: false })
                this.setState({ relSol3BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol4ButtonPress = async () => {
        try {
            if (!this.state.relSol4BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol4, state: true })
                this.setState({ relSol4BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol4ButtonRelease = async () => {
        try {
            if (this.state.relSol4BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol4, state: false })
                this.setState({ relSol4BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol5ButtonPress = async () => {
        try {
            if (!this.state.relSol5BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol5, state: true })
                this.setState({ relSol5BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol5ButtonRelease = async () => {
        try {
            if (this.state.relSol5BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol5, state: false })
                this.setState({ relSol5BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol6ButtonPress = async () => {
        try {
            if (!this.state.relSol6BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol6, state: true })
                this.setState({ relSol6BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol6ButtonRelease = async () => {
        try {
            if (this.state.relSol6BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol6, state: false })
                this.setState({ relSol6BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol7ButtonPress = async () => {
        try {
            if (!this.state.relSol7BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol7, state: true })
                this.setState({ relSol7BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol7ButtonRelease = async () => {
        try {
            if (this.state.relSol7BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol7, state: false })
                this.setState({ relSol7BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol8ButtonPress = async () => {
        try {
            if (!this.state.relSol8BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol8, state: true })
                this.setState({ relSol8BtnPressing: true })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    handleRelSol8ButtonRelease = async () => {
        try {
            if (this.state.relSol8BtnPressing) {
                await updateClientPeripherals(this.props.clientId, { type: PeripheralType.RelSol8, state: false })
                this.setState({ relSol8BtnPressing: false })
            }
        } catch (err) {
            console.error(err)
            toast.error((err as Error).message)
        }
    }

    render() {
        return (
            <div>
                {this.renderActions()}
                {this.renderTestEnvironment()}
            </div>
        )
    }

    renderActions() {
        const { testEnv } = this.state
        return (
            <div className="grid grid-cols-2 gap-5">
                {this.renderActionButton(getString('system_actions.restart'), this.saveSystemAction.bind(this))}
                {this.renderActionButton(
                    getString(testEnv ? 'system_actions.test_env_disable' : 'system_actions.test_env_enable'),
                    this.toggleTestEnv.bind(this),
                    testEnv ? 'yellow' : undefined,
                    testEnv === undefined,
                )}
            </div>
        )
    }

    renderActionButton(
        label: string,
        onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
        color: string = 'indigo',
        disabled = false,
    ) {
        const { working } = this.state
        return (
            <button
                onClick={onClick}
                className={classNames(
                    /**
                     * PurgeCSS:
                     * bg-red-600
                     * bg-green-600
                     * bg-yellow-600
                     * bg-gray-600
                     * bg-purple-600
                     * bg-indigo-600
                     * bg-blue-600
                     * bg-pink-600
                     * hover:bg-red-700
                     * hover:bg-green-700
                     * hover:bg-yellow-700
                     * hover:bg-gray-700
                     * hover:bg-purple-700
                     * hover:bg-indigo-700
                     * hover:bg-blue-700
                     * hover:bg-pink-700
                     * focus:ring-red-501
                     * focus:ring-green-501
                     * focus:ring-yellow-501
                     * focus:ring-gray-501
                     * focus:ring-purple-501
                     * focus:ring-indigo-501
                     * focus:ring-blue-501
                     * focus:ring-pink-501
                     */
                    `group py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-${color}-600 hover:bg-${color}-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-501`,
                )}
                disabled={working || disabled}
            >
                {label}
            </button>
        )
    }

    renderTestEnvironment() {
        if (!this.state.testEnv) return undefined
        return (
            <div>
                {this.renderPeripheralButtons()}
                {this.renderSystemInfo()}
            </div>
        )
    }

    renderPeripheralButtons() {
        return (
            <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-1">
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol1'),
                    !this.state.relSol1BtnPressing ? this.handleRelSol1ButtonPress.bind(this) : this.handleRelSol1ButtonRelease.bind(this),
                    this.state.relSol1BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol2'),
                    !this.state.relSol2BtnPressing ? this.handleRelSol2ButtonPress.bind(this) : this.handleRelSol2ButtonRelease.bind(this),
                    this.state.relSol2BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol3'),
                    !this.state.relSol3BtnPressing ? this.handleRelSol3ButtonPress.bind(this) : this.handleRelSol3ButtonRelease.bind(this),
                    this.state.relSol3BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol4'),
                    !this.state.relSol4BtnPressing ? this.handleRelSol4ButtonPress.bind(this) : this.handleRelSol4ButtonRelease.bind(this),
                    this.state.relSol4BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol5'),
                    !this.state.relSol5BtnPressing ? this.handleRelSol5ButtonPress.bind(this) : this.handleRelSol5ButtonRelease.bind(this),
                    this.state.relSol5BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol6'),
                    !this.state.relSol6BtnPressing ? this.handleRelSol6ButtonPress.bind(this) : this.handleRelSol6ButtonRelease.bind(this),
                    this.state.relSol6BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol7'),
                    !this.state.relSol7BtnPressing ? this.handleRelSol7ButtonPress.bind(this) : this.handleRelSol7ButtonRelease.bind(this),
                    this.state.relSol7BtnPressing ? 'green' : undefined,
                )}
                {this.renderPeripheralButton(
                    getString('common.activate', 'system_actions.rel_sol8'),
                    !this.state.relSol8BtnPressing ? this.handleRelSol8ButtonPress.bind(this) : this.handleRelSol8ButtonRelease.bind(this),
                    this.state.relSol8BtnPressing ? 'green' : undefined,
                )}
            </div>
        )
    }

    renderPeripheralButton(label: string, onClick: Function, color = 'blue') {
        return (
            <button
                onClick={onClick as any}
                // onTouchStart={pressCallback as any}
                // onTouchEnd={releaseCallback as any}
                // onMouseDown={pressCallback as any}
                // onMouseUp={releaseCallback as any}
                // onMouseLeave={releaseCallback as any}
                className={classNames(
                    /**
                     * PurgeCSS:
                     * bg-red-600
                     * bg-green-600
                     * bg-yellow-600
                     * bg-gray-600
                     * bg-purple-600
                     * bg-indigo-600
                     * bg-blue-600
                     * bg-pink-600
                     * hover:bg-red-700
                     * hover:bg-green-700
                     * hover:bg-yellow-700
                     * hover:bg-gray-700
                     * hover:bg-purple-700
                     * hover:bg-indigo-700
                     * hover:bg-blue-700
                     * hover:bg-pink-700
                     * focus:ring-red-501
                     * focus:ring-green-501
                     * focus:ring-yellow-501
                     * focus:ring-gray-501
                     * focus:ring-purple-501
                     * focus:ring-indigo-501
                     * focus:ring-blue-501
                     * focus:ring-pink-501
                     */
                    `group py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-${color}-600 hover:bg-${color}-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${color}-501`,
                )}
            >
                {label}
            </button>
        )
    }

    renderSystemInfo() {
        return (
            <div className="mt-5">
                <SystemInfo clientId={this.props.clientId} intervalOption={1} />
            </div>
        )
    }
}

export default SystemActionsTab
